import { jsx } from "react/jsx-runtime";
import { Suspense, lazy, useMemo } from "react";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-content-preset.tsx
var LazyContentPreset = lazy(() => import("./content-preset-CsyFBZLj.js").then((n) => n.n).then((module) => ({ default: module.ContentPreset })));
function ContentPreset({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "content-preset" }),
		children: /* @__PURE__ */ jsx(LazyContentPreset, { ...props })
	});
}
function ContentPresetContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "content-preset" }),
		children: /* @__PURE__ */ jsx(LazyContentPreset, { ...props })
	});
}
var useContentPresetContent = () => {
	return useMemo(() => ({ contentPreset: { component: ContentPresetContent } }), []);
};
//#endregion
export { ContentPreset, useContentPresetContent };
